import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';
import { ButtonBase } from '../../../../shared/Button';
import { PillButton } from '../../../../shared/Button/PillButton';
import { scrollToStep } from '../../utils/scrollTo';

import { SkippedState } from '../UserUpload/SkippedState.jsx';
import { useCampaignContext } from '../../contexts/CampaignContext.jsx';

export const NoPrize = ({ nextStep, openPrizeModal }) => {
  const { t } = useTranslation('campaigns');
  const [skippedStep, setSkippedStep] = useState(false);

  const skipStep = () => {
    setSkippedStep(true);
    scrollToStep(nextStep);
  };

  const resetState = () => {
    setSkippedStep(false);
  };

  const { campaign } = useCampaignContext();
  const isDisabled = campaign.isArchived || !!campaign.deletedAt;

  return (
    <>
      {skippedStep ? (
        <SkippedState resetState={resetState} />
      ) : (
        <>
          <Text variant="subtitle2" opacity="0.4">
            {t('prizes.noPrizes')}
          </Text>
          <PillButton
            variant="primary"
            mode="outline"
            disabled={isDisabled}
            onClick={openPrizeModal}
          >
            <Gift />
            <Text color="primary.100" variant="subtitle2">
              {t('prizes.setPrizes')}
            </Text>
          </PillButton>

          <Skip onClick={skipStep} mode="text" variant="primary">
            {t('prizes.skip')}
          </Skip>
        </>
      )}
    </>
  );
};

const Skip = styled(ButtonBase)`
  height: auto;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
`;

const Gift = styled.i.attrs({
  className: 'fa-light fa-gift',
})`
  margin-right: 6px;
`;
